import { render } from "./TopHome.vue?vue&type=template&id=b2068c3a"
import script from "./TopHome.vue?vue&type=script&lang=js"
export * from "./TopHome.vue?vue&type=script&lang=js"
script.render = render

export default script